<template>
  <button>{{ text }}</button>
</template>

<script>
export default {
  props: {
    text: String
  }
}
</script>

<style lang="scss" scoped>
button {
  background: #fff;
  border: none;
  border-radius: 67px;
  box-shadow: 0 20px 30px rgba(0,0,0,0.33);
  color: #000;
  font-size: 18px;
  height: 67px;
  letter-spacing: 2px;
  line-height: 67px;
  text-transform: uppercase;
  width: 217px;
  font-weight: bold;
}
</style>